package com.esoris.kmpmoout.domaindata.expense

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ExpenseDto(

    @SerialName("id")
    val id: String,

    @SerialName("user_id")
    val userId: String,

    @SerialName("amount")
    val amount: Long,

    @SerialName("category")
    val category: String,

    @SerialName("note")
    val note: String? = null,

    @SerialName("created_at")
    val createdAt: String? = null
)
